export default __webpack_public_path__ + "static/media/dsstest14.84bf2550.jpg";